import { z } from 'zod';
import { PROTOCOL_TARGETS, PROTOCOL_TYPES, REMINDER_STATUSES, REMINDER_TYPES } from '../enums';
import { clientCreatedAt, isoDate, isoDateTime, optText, text, uuid, type SyncFields } from './common';

/** BR-9, D-5. Deterministic id (D-13). */
export const reminderSchema = z.object({
  animalId: uuid,
  type: z.enum(REMINDER_TYPES),
  dueDate: isoDate,
  windowEnd: isoDate.nullish(),
  status: z.enum(REMINDER_STATUSES).default('OPEN'),
  sourceEventId: uuid.nullish(),
  protocolId: uuid.nullish(),
  completedAt: isoDateTime.nullish(),
  completedBy: uuid.nullish(),
  note: optText(500),
  clientCreatedAt,
});

export type ReminderData = z.output<typeof reminderSchema>;
export type ReminderRecord = ReminderData & SyncFields;

/** HE-4. */
export const healthProtocolSchema = z.object({
  type: z.enum(PROTOCOL_TYPES),
  name: text(60),
  product: optText(80),
  intervalDays: z.number().int().min(1).max(730),
  target: z.enum(PROTOCOL_TARGETS),
  firstDueAgeDays: z.number().int().min(0).max(3650).nullish(),
  active: z.boolean().default(true),
  clientCreatedAt,
});

export type HealthProtocolData = z.output<typeof healthProtocolSchema>;
export type HealthProtocolRecord = HealthProtocolData & SyncFields;
